import {
	createRouter,
	createWebHashHistory,
	createWebHistory
} from "vue-router";
import {
	useUserStore
} from "@/stores/user";

const routes = [{
		path: "/domain-invalid",
		name: "DomainInvalid",
		component: () => import("@/pages/domain-invalid/index.vue"),
	},
	{
		path: "/",
		component: () => import("components/layouts/index.vue"),
		children: [{
				path: "/",
				name: "home",
				component: () => import("@/pages/home/index.vue"),
			},
			{
				path: '/casino',
				name: 'Casino',
				component: () => import('@/pages/casino/index.vue'),
			},
			{
				path: '/sports',
				name: 'SportsRoot',
				component: () => import('@/pages/sports/index.vue'),
				meta: {
					title: 'Sports'
				}
			},
			{
				path: '/pwa',
				name: 'Pwa',
				component: () => import('@/pages/pwa/index.vue'),
				meta: {
					title: 'Pwa',
					hiddenLayout: true, 
				}
			},

			// 通配符路由（必須放在後面）
			{
				path: '/sports/:pathMatch(.*)*',
				name: 'Sports',
				component: () => import('@/pages/sports/index.vue'),
				meta: {
					title: 'Sports',
					requiresAuth: false
				}
			},
			{
				path: '/live',
				name: 'Live',
				component: () => import('@/pages/live/index.vue'),
			},
			{
				path: '/vip',
				name: 'Vip',
				component: () => import('@/pages/vip/index.vue'),
			},
			{
				path: '/bonus-center',
				name: 'Bonus Center',
				component: () => import('@/pages/bonus-center/index.vue'),
			},
			{
				path: '/affiliate',
				name: 'Affiliate',
				component: () => import('@/pages/affiliate/index.vue'),
			},
			{
				path: '/promotion',
				name: 'Promotion',
				component: () => import('@/pages/promotion/index.vue'),
			},
			{
				path: '/promotion/detail',
				name: 'Promotion Detail',
				component: () => import('@/pages/promotion/detail.vue'),
			},
			{
				path: '/promotion/wheel',
				name: 'Promotion Wheel',
				component: () => import('@/pages/promotion/wheel.vue'),
			},
			{
				path: '/promotion/mobileWheel',
				name: 'Promotion mobileWheel',
				component: () => import('@/pages/promotion/mobileWheel.vue'),
			},
			{
				path: '/promotion/machine',
				name: 'Promotion machine',
				component: () => import('@/pages/promotion/machine.vue'),
			},
			{
				path: '/promotion/mobileMachine',
				name: 'Promotion mobileMachine',
				component: () => import('@/pages/promotion/mobileMachine.vue'),
			},
			{
				path: '/promotion/collection',
				name: 'Promotion collection',
				component: () => import('@/pages/promotion/collection/index.vue'),
			},
			{
				path: '/rewards',
				name: 'Rewards',
				component: () => import('@/pages/rewards/index.vue'),
			},
			{
				path: '/help',
				name: 'Help',
				component: () => import('@/pages/help/index.vue'),
			},
			{
				path: '/feedback',
				name: 'Feedback',
				component: () => import('@/pages/feedback/index.vue'),
			},
			{
				path: '/install',
				name: 'Install',
				component: () => import('@/pages/install/index.vue'),
			},
			{
				path: '/collections',
				name: 'Collections',
				component: () => import('@/pages/collections/index.vue'),
			},
			{
				path: '/game',
				name: 'Game',
				component: () => import('@/pages/game/index.vue'),
			},
			{
				path: '/gameLauncher',
				name: 'GameLauncher',
				component: () => import('@/pages/game/gameLauncher.vue'),
			},
			{
				path: '/porfile',
				name: 'Profile',
				component: () => import('@/pages/account/index.vue'),
			},
			{
				// 兼容旧路径，重定向到 /porfile
				path: '/account',
				redirect: '/porfile',
			},
			{
				path: '/wallet',
				name: 'Wallet',
				component: () => import('@/pages/wallet/layout.vue'),
				children: [{
						path: 'balance',
						name: 'Balance',
						component: () => import('@/pages/wallet/balance.vue'),
					},
					{
						path: 'deposit',
						name: 'Deposit',
						component: () => import('@/pages/wallet/deposit.vue'),
					},
					{
						path: 'withdraw',
						name: 'Withdraw',
						component: () => import('@/pages/wallet/withdraw.vue'),
					},
					// vault disabled
					// {
					//     path: 'vault',
					//     name: 'Vault',
					//     component: () => import('@/pages/wallet/vault.vue'),
					// },
					{
						path: 'transaction',
						name: 'Transaction',
						component: () => import('@/pages/wallet/transaction.vue'),
					},
					{
						path: 'rollover',
						name: 'Rollover',
						component: () => import('@/pages/wallet/rollover.vue'),
					},
					{
						path: 'my-bet',
						name: 'My Bet',
						component: () => import('@/pages/wallet/myBet.vue'),
					}
				]
			},
			{
				path: '/settings',
				name: 'Settings',
				component: () => import('@/pages/settings/layout.vue'),
				children: [{
						path: 'account',
						name: 'Account',
						component: () => import('@/pages/settings/account.vue'),
					},
					{
						path: 'security',
						name: 'Security',
						component: () => import('@/pages/settings/security.vue'),
					},
					{
						path: 'verify',
						name: 'Verify',
						component: () => import('@/pages/settings/verify.vue'),
					}
				]
			}
		],
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	// 处理滚动行为
	scrollBehavior(to, from, savedPosition) {
		// 如果有保存的位置（浏览器前进/后退），使用保存的位置
		if (savedPosition) {
			return savedPosition;
		} else {
			// 否则滚动到顶部
			return {
				left: 0,
				top: 0
			};
		}
	}
});

router.beforeEach((to, from, next) => {
	if (window.__SKIP_BEFORE_EACH) {
		window.__SKIP_BEFORE_EACH = false;
		next();
		return;
	}

	// 结算中禁止进入游戏页面
	if ((to.path === '/game' || to.path === '/gameLauncher') && useUserStore().settling) {
		window.dispatchEvent(new CustomEvent('settle:blocked'));
		next(false);
		return;
	}

	// 捕获渠道推广参数
	const channelCode = to.query.ch;
	if (channelCode) {
		const userStore = useUserStore();
		userStore.channelCode = String(channelCode);
		userStore.promotionDomain = `${window.location.host}${to.path}?ch=${channelCode}`;
		localStorage.setItem('promotion_channel_code', userStore.channelCode);
		localStorage.setItem('promotion_domain', userStore.promotionDomain);
		localStorage.setItem('promotion_url', window.location.href);
		const query = {
			...to.query
		};
		delete query.ch;
		next({
			path: to.path,
			query,
			replace: true
		});
		return;
	}

	// 捕获邀请码参数
	const inviteCode = to.query.ic;
	if (inviteCode) {
		const userStore = useUserStore();
		userStore.invitationCode = inviteCode;
		const query = {
			...to.query
		};
		delete query.ic;
		next({
			path: to.path,
			query,
			replace: true
		});
		return;
	}

	if (from.hash) {
		try {
			const item = window.__VUE_DIALOG_CLOSE_REGISTRY.find(
				(item) => from.hash.includes(item.key)
			);
			if (item) item.close(null, true);
		} catch (e) {}
	}

	next();
});

export default router;